import React, { useState } from 'react';
import {
  Grid,
  Typography,
  makeStyles,
  Divider,
  Box,
  Paper,
} from '@material-ui/core';
// import CrossIcon from '../assets/icons/cross.svg';
import { Link, useLocation } from 'react-router-dom';
import Header from './Header';
import RightArrowIcon from '../assets/icons/Arrowright.svg';
import KenButton from '../components/KenButton';
import { useHistory } from 'react-router-dom';
import { getacademicProgramInfo } from '../utils/ApiService';
import KenLoader from '../components/KenLoader/KenLoader';

const useStyles = makeStyles((theme) => ({
  headerGrid: {
    width: '48%',
    margin: '0 auto',
    marginTop: 40,
  },
  bodyGrid: {
    width: '77%',
    margin: '0 auto',
    marginBottom: 24,
    display: 'flex',
    justifyContent: 'center',
  },
  heading1: {
    fontSize: '16px',
    color: theme.palette.KenColors.neutral900,
    marginBottom: 24,
  },
  paper: {
    padding: 40,
    marginBottom: 24,
    textAlign: 'left',
    boxShadow: `0px 0px 9px ${theme.palette.KenColors.shadowColor}`,
  },
  data: {
    marginTop: 12,
    fontSize: '14px',
    opacity: '0.5',
  },
  heading2: {
    fontSize: '16px',
    color: theme.palette.KenColors.neutral900,
    marginBottom: 24,
    marginTop: 32,
  },
  subHeading: {
    fontSize: '14px',
    opacity: '0.5',
    marginBottom: 12,
  },
  link: {
    textDecoration: 'none',
  },
  data1:{
    fontSize: '12px',
  }
}));
export default function Instruction(props) {
  const classes = useStyles();
  const query = new URLSearchParams(useLocation().search);
  const initValues=[
    {"InstituteId":"001N0000023jnbRIAQ",
     "Institute":"ESSCI", 
     "Department":"", 
     "Id":"001N0000023jncPIAQ", 
     "academicprogram":"Training Partner", 
     "Fees":null, "StartDate":"2021-10-03",
      "EndDate":"2022-02-02", "CurrencyCodec":null, "CurrencySymbolc":null, "AcademicYear":2021, "internationalFees":null, "internationalCurrencyCodec":null, "internationalCurrencySymbolc":null, "ApplicableFees":"Indian", "Type":null}]
  const [academicProgramsDetails, setacademicProgramsDetails] = useState(initValues);
  const [loader, setLoader] = React.useState(true);

  // console.log(query,'[Instructions] Router State: ',query.get("name"));
  // React.useEffect(() => {
  //   setLoader(true);
  //   getacademicProgramInfo(query.get('name'), query.get('year')).then((res) => {
  //     setacademicProgramsDetails(res[0]);
  //     setLoader(false);
  //   });
  // }, []);
  // props.history.location.state.academicProgramDetails = academicProgramsDetails;

  // const firstName = props.history?.location.state?.userDetails?.First_Name;
  // const lastName = props.history?.location.state?.userDetails?.Last_Name;
  const firstName = "test"
  const lastName ="test"
  return (
    <div>
      <Grid container justify="space-between" className={classes.headerGrid}>
        <Grid item>
          <Header
            title="Training Partner"
            firstName="Test"
            lastName="User"
            isLogo={false}
            startDate={academicProgramsDetails?.StartDate}
            endDate={academicProgramsDetails?.EndDate}
            Fees={academicProgramsDetails?.Fees}
            internationalFees={academicProgramsDetails?.internationalFees}
            internationalCurrencySymbolc={
              academicProgramsDetails?.internationalCurrencySymbolc
            }
            currencySymbolc={academicProgramsDetails?.CurrencySymbolc}
          >
            {/* {loader && <KenLoader />} */}
          </Header>
        </Grid>
      </Grid>
      <Box mb={3} mt={3} style={{ width: '100%' }}>
        <Grid container className={classes.bodyGrid}>
          <Grid item>
            <Paper elevation={0} className={classes.paper}>
              <Typography className={classes.heading1}>INSTRUCTIONS</Typography>
              <Divider />
              <br />
              <Typography className={classes.heading1}>
                Important Notes
              </Typography>
              <Typography className={classes.data}>
                1. All the fields are required unless marked optional.
              </Typography>
              <Typography className={classes.data}>
                2. Application Fees of INR 6000 has to be paid online in the
                Payment section.
              </Typography>
              <Typography className={classes.data}>
                3. Contact Details:
                <Box ml={2}>
                  <Typography className={classes.data1}>
                    Electronic Sector Skills Council of India
                  </Typography>
                  <Typography className={classes.data1}>
                    Head office: 602-04-06-608, 6th Floor, Ansal Chambers II,
                    Bhikaji Cama
                  </Typography>
                  <Typography className={classes.data1}>
                    Place, New Delhi – 110066
                  </Typography>
                  <Typography className={classes.data1}>
                    Email ID: pratiksha@essc-india.org,annamalai@essc-india.org
                  </Typography>
                  <Typography className={classes.data1}>
                    Phone Number: 9971193490
                  </Typography>
                </Box>
              </Typography>

              <Typography className={classes.heading2}>
                Mandatory Documents
              </Typography>
              <Typography className={classes.subHeading}>
                Please ensure that you possess the following documents for
                upload before continuing
              </Typography>
              <Typography className={classes.data}>
                Registration Certificate
              </Typography>
              <Typography className={classes.data}>
                GSTIN certificate and PAN Card
              </Typography>
              <Typography className={classes.data}>
                Last 3 Years Audited Balance Sheet
              </Typography>
              <Typography className={classes.data}>
                TC Organisation Chart
              </Typography>
              <Typography className={classes.data}>
                Trainer CVs along with supporting documents
              </Typography>
              <Typography className={classes.data}>
                Administrative Support Staff Employment Proof docs
              </Typography>
              <Typography className={classes.data}>
                Operations Manual
              </Typography>
            </Paper>
          </Grid>
          <Grid item container justify="center" alignItems="center">
            <Link
              className={classes.link}
              to={{
                pathname: `/form/${props?.match?.params?.id}`,
                state: useLocation().state,
              }}
            >
              <KenButton
                variant="primary"
                endIcon={<img src={RightArrowIcon} alt="i" />}
              >
                Continue
              </KenButton>
            </Link>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
